<div id="listCard" class="card p-2 animate__animated animate__backInDown">
  <app-pctable-action
    [data]="action"
    [header]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable-action>

  <app-pctable
    [data]="data"
    [entityField]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable>

  <app-pcpaging [paging]="paging" (parentAction)="parentAction($event)">
  </app-pcpaging>

  <app-loading-panel *ngIf="loading"> </app-loading-panel>
</div>

<app-pcsetting-modal (parentAction)="parentAction($event)" [fields]="fields">
</app-pcsetting-modal>

<ng-template #removeLack let-modal class="modal modal-top fade">
  <div class="modal-header border-bottom p-3">
    <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
      {{ "RemoveLack" | translate }}
    </h6>
    <button
      type="button"
      class="btn-close-modal btn-icon btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>

  <div class="modal-body border-bottom">
    <app-remove-lack
      [data]="factorDetail"
      [stockList]="stockList"
      (parentActionOutput)="parentAction($event)"
    >
    </app-remove-lack>
  </div>

  <div class="modal-footer justify-content-center p-2">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.dismiss('Cross click')"
    >
      <i class="bx bx-x"></i>
      {{ "Close" | translate }}
    </button>
  </div>
</ng-template>

<ng-template #factorDetailModal let-modal class="modal modal-top fade">
  <div class="modal-header border-bottom p-3">
    <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
      {{ "FactorDetail" | translate }}
    </h6>
    <button
      type="button"
      class="btn-close-modal btn-icon btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>

  <div class="modal-body border-bottom">
    <div class="card-modal mx-2 ms-2" style="width: auto;">
      <div class="row mx-3 my-0">
        <div class="col-6 col-md-6 col-lg-2 fs-6 fw-bold">
          <span class="px-0 pe-0">{{ "FactorId" | translate }}</span>
        </div>
        <div class="col-6 col-md-6 col-lg-2 fs-6">
          <p class="m-0 px-0">
            {{ factorDetail.factorId }}
          </p>
        </div>
        <div class="col-6 col-md-6 col-lg-2 fs-6 fw-bold">
          <span class="px-0 pe-0">{{ "FactorDate" | translate }}</span>
        </div>
        <div class="col-6 col-md-6 col-lg-2 fs-6">
          <p class="m-0 px-0">
            {{ factorDetail.factorDate | dataType : "" }}
          </p>
        </div>
        <div class="col-6 col-md-6 col-lg-2 fs-6 fw-bold">
          <span class="px-0 pe-0">{{ "CompanyName" | translate }}</span>
        </div>
        <div class="col-6 col-md-6 col-lg-2 fs-6">
          <p class="m-0 px-0">
            {{ factorDetail.companyName }}
          </p>
        </div>
      </div>
      <div class="row mx-3 my-0">
        <div class="col-6 col-md-6 col-lg-2 fs-6 fw-bold">
          <span class="px-0 pe-0">{{ "TotalPrice" | translate }}</span>
        </div>
        <div class="col-6 col-md-6 col-lg-2 fs-6">
          <p class="m-0 px-0">
            {{ factorDetail.totalPrice }}
          </p>
        </div>
        <div class="col-6 col-md-3 col-lg-2 fs-6 fw-bold">
          <span class="px-0 pe-0">{{ "discount" | translate }}</span>
        </div>
        <div class="col-6 col-md-3 col-lg-2 fs-6">
          <p class="m-0 px-0">
            {{ factorDetail.discount }}
          </p>
        </div>
        <div class="col-6 col-md-3 col-lg-2 fs-6 fw-bold">
          <span class="px-0 pe-0">{{ "state" | translate }}</span>
        </div>
        <div class="col-6 col-md-3 col-lg-2 fs-6">
          <p class="m-0 px-0">
            {{ factorDetail.state }}
          </p>
        </div>
      </div>
      <div class="row mx-3 my-0 border-ridge">
        <div class="col-4 col-md-3 col-lg-2 fs-6 fw-bold">
          <span class="m-0 px-0">{{ "Description" | translate }} </span>
        </div>
        <div class="col-8 col-md-9 col-lg-10 fs-6">
          <p class="m-0 px-0">
            {{ factorDetail.description }}
          </p>
        </div>
      </div>
    </div>

    <div class="row p-1 drug-list" style="width: auto;">
      <div class="mvc-grid-table">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th scope="col">{{ "Row" | translate }}</th>
              <th scope="col">{{ "drugBrandName" | translate }}</th>
              <th scope="col">{{ "Number" | translate }}</th>
              <th scope="col">{{ "Lack" | translate }}</th>
              <th scope="col">{{ "expireDate" | translate }}</th>
              <th scope="col">{{ "buyPrice" | translate }}</th>
              <th scope="col">{{ "buyDiscount" | translate }}</th>
              <th scope="col">{{ "TotalAmount" | translate }}</th>
            </tr>
          </thead>
          <tbody id="rows">
            <tr *ngFor="let item of factorDetail.returnDrug; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ item.drugName }}</td>
              <td>{{ item.count }}</td>
              <td>{{ item.shortageCount }}</td>
              <td>{{ item.expireDate | dataType : "" : false }}</td>
              <td>
                {{ item.buyPrice | number }}
                {{ "Rial" | translate }}
              </td>
              <td>
                {{ item.buyDiscount | number }}
                {{ "Rial" | translate }}
              </td>
              <td>
                {{ item.totalPrice | number }}
                {{ "Rial" | translate }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="modal-footer justify-content-center p-2">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.dismiss('Cross click')"
    >
      <i class="bx bx-x"></i>
      {{ "Close" | translate }}
    </button>
  </div>
</ng-template>

<ng-template #factorReturnModal let-modal class="modal modal-top fade">
  <div class="modal-header border-bottom p-3">
    <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
      {{ "FactorReturn" | translate }}
    </h6>
    <button
      type="button"
      class="btn-close-modal btn-icon btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>

  <div class="modal-body border-bottom">
    <div class="card-modal mx-2 ms-2" style="width: auto;">
      <div class="row mx-3 my-0">
        <div class="col-6 col-md-6 col-lg-2 fs-6  fw-bold">
          <span class="px-0 pe-0">{{ "FactorId" | translate }}</span>
        </div>
        <div class="col-6 col-md-6 col-lg-2 fs-6 ">
          <p class="m-0 px-0">
            {{ factorDetail.factorId }}
          </p>
        </div>
        <div class="col-6 col-md-6 col-lg-2 fs-6  fw-bold">
          <span class="px-0 pe-0">{{ "FactorDate" | translate }}</span>
        </div>
        <div class="col-6 col-md-6 col-lg-2 fs-6 ">
          <p class="m-0 px-0">
            {{ factorDetail.factorDate | dataType : "" }}
          </p>
        </div>
        <div class="col-6 col-md-6 col-lg-2 fs-6  fw-bold">
          <span class="px-0 pe-0">{{ "CompanyName" | translate }}</span>
        </div>
        <div class="col-6 col-md-6 col-lg-2 fs-6 ">
          <p class="m-0 px-0">
            {{ factorDetail.companyName }}
          </p>
        </div>
      </div>
      <div class="row mx-3 my-0">
        <div class="col-6 col-md-6 col-lg-2 fs-6  fw-bold">
          <span class="px-0 pe-0">{{ "TotalPrice" | translate }}</span>
        </div>
        <div class="col-6 col-md-6 col-lg-2 fs-6 ">
          <p class="m-0 px-0">
            {{ factorDetail.totalPrice }}
          </p>
        </div>
        <div class="col-6 col-md-3 col-lg-2 fs-6 fw-bold">
          <span class="px-0 pe-0">{{ "discount" | translate }}</span>
        </div>
        <div class="col-6 col-md-3 col-lg-2 fs-6">
          <p class="m-0 px-0">
            {{ factorDetail.discount }}
          </p>
        </div>
        <div class="col-6 col-md-3 col-lg-2 fs-6 fw-bold">
          <span class="px-0 pe-0">{{ "state" | translate }}</span>
        </div>
        <div class="col-6 col-md-3 col-lg-2 fs-6">
          <p class="m-0 px-0">
            {{ factorDetail.state }}
          </p>
        </div>
      </div>
      <div class="row mx-3 my-0 border-ridge">
        <div class="col-4 col-md-3 col-lg-2 fs-6 fw-bold">
          <span class="m-0 px-0">{{ "Description" | translate }} </span>
        </div>
        <div class="col-8 col-md-9 col-lg-10 fs-6">
          <p class="m-0 px-0">
            {{ factorDetail.description }}
          </p>
        </div>
      </div>
    </div>

    <div class="row p-1" style="width: auto;">
      <div class="mvc-grid-table">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th scope="col">{{ "Row" | translate }}</th>
              <th scope="col">{{ "drugBrandName" | translate }}</th>
              <th scope="col">{{ "Number" | translate }}</th>
              <!-- <th scope="col">{{ "Inventory" | translate }}</th> -->
              <th scope="col">{{ "expireDate" | translate }}</th>
              <th scope="col">{{ "buyPrice" | translate }}</th>
              <th scope="col">{{ "buyDiscount" | translate }}</th>
              <th scope="col">{{ "TotalAmount" | translate }}</th>
              <th scope="col">{{ "ReturnCount" | translate }}</th>
            </tr>
          </thead>
          <tbody id="rows">
            <ng-container
              *ngFor="let item of factorDetail.returnDrug; let i = index"
            >
              <tr (click)="item.isSelected = !item.isSelected">
                <td>{{ i + 1 }}</td>
                <td>{{ item.drugName }}</td>
                <td>{{ item.count }}</td>
                <!-- <td>{{ item.inventory }}</td> -->
                <td>{{ item.expireDate | dataType : "" : false }}</td>
                <td>
                  {{ item.buyPrice | number }}
                  {{ "Rial" | translate }}
                </td>
                <td>
                  {{ item.buyDiscount | number }}
                  {{ "Rial" | translate }}
                </td>
                <td>
                  {{ item.totalPrice | number }}
                  {{ "Rial" | translate }}
                </td>
                <td>
                  <input
                    id="ReturnCount"
                    type="number"
                    autocomplete="off"
                    appSelectOnFocus
                    class="form-control"
                    [ngClass]="{
                      'is-invalid':
                        item.alertMessage != undefined &&
                        item.alertMessage != ''
                    }"
                    [(ngModel)]="item.returnCount"
                    (ngModelChange)="item.alertMessage = undefined"
                  />
                </td>
              </tr>
              <tr
                class="return-description"
                [class]="{
                  'hide-return-description':
                    item.returnCount == null || item.returnCount == 0
                }"
              >
                <td colspan="9">
                  <div class="col-12 top-input-box mt-3">
                    <label for="description" class="form-label m-0"
                      >{{ "description" | translate }}:</label
                    >
                    <textarea
                      id="description"
                      type="text"
                      class="form-control"
                      placeholder="{{ 'description' | translate }}"
                      [(ngModel)]="item.description"
                    ></textarea>
                    <p class="validation-alert-pc-modal">
                      {{ item.alertMessage }}
                    </p>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <app-loading-panel *ngIf="loading"></app-loading-panel>

  <div class="modal-footer justify-content-center p-2">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.dismiss('Cross click')"
    >
      <i class="bx bx-x"></i>
      {{ "Close" | translate }}
    </button>
    <button
      type="submit"
      class="btn btn-primary me-sm-3 me-1 data-submit"
      (click)="ImportReturnFactor()"
    >
      <i class="bx bx-check"></i>
      {{ "Submit" | translate }}
    </button>
  </div>
</ng-template>

<ng-template #searchFilter let-modal class="modal modal-top fade">
  <div class="modal-header border-bottom p-3">
    <h6 id="title-header" class="title-header">
      {{ "SearchFilter" | translate }}
    </h6>
    <button
      type="button"
      class="btn-close-modal btn-icon btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div
        class="col-12 col-xxl-6 col-xl-6 col-lg-12 col-md-12 mb-2 padding-mobile-size"
      >
        <div class="row input-box drug-information-box ms-1 p-2 mb-2">
          <div class="col-12 mb-3">
            <div class="input-box-title-box px-2">
              <span>{{ "DateFilter" | translate : "" }}</span>
            </div>
            <div class="edit-form">
              <label class="form-label m-0">
                {{ "FactorDate" | translate }}
              </label>
              <div
                class="input-group input-daterange"
                id="bs-datepicker-daterange"
              >
                <span class="input-group-text label-span">
                  {{ "From" | translate }}
                </span>
                <input
                  type="text"
                  id="from-factor-date"
                  [disabled]="endPoint == 'BuyFactor'"
                  autocomplete="off"
                  placeholder="YYYY/MM/DD"
                  [ngModel]="filterData.FactorDateFrom | dataType : '' : false"
                  class="form-control"
                  [ngbPopover]="popoverFactorDateFromDatePicker"
                  (keyup.delete)="filterData.FactorDateFrom = undefined"
                  [autoClose]="'outside'"
                  #datePicker="ngbPopover"
                  (ngModelChange)="
                    filterData.FactorDateFrom =
                      calendarService.TypeDate('from-factor-date')
                  "
                />
                <ng-template #popoverFactorDateFromDatePicker>
                  <app-data-picker
                    [(childProp)]="filterData.FactorDateFrom"
                    (changeVariableMonth)="changeMonth($event)"
                  ></app-data-picker>
                </ng-template>
                <button
                  class="input-group-text"
                  [disabled]="endPoint=='BuyFactor'"
                  [ngbPopover]="popoverFactorDateFromDatePicker"
                  [autoClose]="'outside'"
                  #datePicker="ngbPopover"
                >
                  <i class="far fa-calendar-alt"></i>
                </button>

                <span class="input-group-text label-span">
                  {{ "To" | translate }}
                </span>

                <input
                  type="text"
                  id="FactorDateTo"
                  [disabled]="endPoint == 'BuyFactor'"
                  autocomplete="off"
                  placeholder="YYYY/MM/DD"
                  appSelectOnFocus
                  appConvertNumbers
                  [ngModel]="filterData.FactorDateTo | dataType : '' : false"
                  class="form-control"
                  [ngbPopover]="popoverFactorDateToDatePicker"
                  (keyup.delete)="filterData.FactorDateTo = undefined"
                  [autoClose]="'outside'"
                  #datePicker="ngbPopover"
                  (ngModelChange)="
                    filterData.FactorDateTo =
                      calendarService.TypeDate('FactorDateTo')
                  "
                />
                <ng-template #popoverFactorDateToDatePicker>
                  <app-data-picker
                    [(childProp)]="filterData.FactorDateTo"
                    (changeVariableMonth)="changeMonth($event)"
                  ></app-data-picker>
                </ng-template>
                <button
                  class="input-group-text"
                  [disabled]="endPoint=='BuyFactor'"
                  [ngbPopover]="popoverFactorDateToDatePicker"
                  [autoClose]="'outside'"
                  #datePicker="ngbPopover"
                >
                  <i class="far fa-calendar-alt"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="col-12 mb-3">
            <div class="edit-form">
              <label class="form-label m-0">
                {{ "DeliveryData" | translate }}
              </label>
              <div
                class="input-group input-daterange"
                id="bs-datepicker-daterange"
              >
                <span class="input-group-text label-span">
                  {{ "From" | translate }}
                </span>
                <input
                  type="text"
                  id="DeliverDateFrom"
                  [disabled]="endPoint == 'BuyFactor'"
                  autocomplete="off"
                  placeholder="YYYY/MM/DD"
                  appSelectOnFocus
                  appConvertNumbers
                  [ngModel]="filterData.DeliverDateFrom | dataType : '' : false"
                  class="form-control"
                  [ngbPopover]="popoverDeliverDateFromDatePicker"
                  (keyup.delete)="filterData.DeliverDateFrom = undefined"
                  [autoClose]="'outside'"
                  #datePicker="ngbPopover"
                  (ngModelChange)="
                    filterData.DeliverDateFrom =
                      calendarService.TypeDate('DeliverDateFrom')
                  "
                />
                <ng-template #popoverDeliverDateFromDatePicker>
                  <app-data-picker
                    [(childProp)]="filterData.DeliverDateFrom"
                    (changeVariableMonth)="changeMonth($event)"
                  ></app-data-picker>
                </ng-template>
                <button
                  class="input-group-text"
                  [ngbPopover]="popoverDeliverDateFromDatePicker"
                  [autoClose]="'outside'"
                  [disabled]="endPoint == 'BuyFactor'"
                  #datePicker="ngbPopover"
                >
                  <i class="far fa-calendar-alt"></i>
                </button>

                <span class="input-group-text label-span">
                  {{ "To" | translate }}
                </span>

                <input
                  type="text"
                  id="DeliverDateTo"
                  [disabled]="endPoint == 'BuyFactor'"
                  autocomplete="off"
                  placeholder="YYYY/MM/DD"
                  appSelectOnFocus
                  appConvertNumbers
                  [ngModel]="filterData.DeliverDateTo | dataType : '' : false"
                  class="form-control"
                  [ngbPopover]="popoverDeliverDateToDatePicker"
                  (keyup.delete)="filterData.DeliverDateTo = undefined"
                  [autoClose]="'outside'"
                  #datePicker="ngbPopover"
                  (ngModelChange)="
                    filterData.DeliverDateTo =
                      calendarService.TypeDate('DeliverDateTo')
                  "
                />
                <ng-template #popoverDeliverDateToDatePicker>
                  <app-data-picker
                    [(childProp)]="filterData.DeliverDateTo"
                    (changeVariableMonth)="changeMonth($event)"
                  ></app-data-picker>
                </ng-template>
                <button
                  class="input-group-text"
                  [disabled]="endPoint == 'BuyFactor'"
                  [ngbPopover]="popoverDeliverDateToDatePicker"
                  [autoClose]="'outside'"
                  #datePicker="ngbPopover"
                >
                  <i class="far fa-calendar-alt"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="col-12 mb-3">
            <div class="edit-form">
              <label class="form-label m-0">
                {{ "DateAdded" | translate }}
              </label>
              <div
                class="input-group input-daterange"
                id="bs-datepicker-daterange"
              >
                <span class="input-group-text label-span">
                  {{ "From" | translate }}
                </span>
                <input
                  type="text"
                  id="AddedDateFrom"
                  [disabled]="endPoint == 'BuyFactor'"
                  autocomplete="off"
                  placeholder="YYYY/MM/DD"
                  [ngModel]="filterData.AddedDateFrom | dataType : '' : false"
                  class="form-control"
                  [ngbPopover]="popoverAddedDateFromDatePicker"
                  (keyup.delete)="filterData.AddedDateFrom = undefined"
                  [autoClose]="'outside'"
                  #datePicker="ngbPopover"
                  (ngModelChange)="
                    filterData.AddedDateFrom =
                      calendarService.TypeDate('AddedDateFrom')
                  "
                />
                <ng-template #popoverAddedDateFromDatePicker>
                  <app-data-picker
                    [(childProp)]="filterData.AddedDateFrom"
                    (changeVariableMonth)="changeMonth($event)"
                  ></app-data-picker>
                </ng-template>
                <button
                  [disabled]="endPoint == 'BuyFactor'"
                  class="input-group-text"
                  [ngbPopover]="popoverAddedDateFromDatePicker"
                  [autoClose]="'outside'"
                  #datePicker="ngbPopover"
                >
                  <i class="far fa-calendar-alt"></i>
                </button>

                <span class="input-group-text label-span">
                  {{ "To" | translate }}
                </span>

                <input
                  type="text"
                  id="AddedDateTo"
                  [disabled]="endPoint == 'BuyFactor'"
                  autocomplete="off"
                  placeholder="YYYY/MM/DD"
                  [ngModel]="filterData.AddedDateTo | dataType : '' : false"
                  class="form-control"
                  [ngbPopover]="popoverAddedDateToDatePicker"
                  (keyup.delete)="filterData.AddedDateTo = undefined"
                  [autoClose]="'outside'"
                  #datePicker="ngbPopover"
                  (ngModelChange)="
                    filterData.AddedDateTo =
                      calendarService.TypeDate('AddedDateTo')
                  "
                />
                <ng-template #popoverAddedDateToDatePicker>
                  <app-data-picker
                    [(childProp)]="filterData.AddedDateTo"
                    (changeVariableMonth)="changeMonth($event)"
                  ></app-data-picker>
                </ng-template>
                <button
                  [disabled]="endPoint == 'BuyFactor'"
                  class="input-group-text"
                  [ngbPopover]="popoverAddedDateToDatePicker"
                  [autoClose]="'outside'"
                  #datePicker="ngbPopover"
                >
                  <i class="far fa-calendar-alt"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-12 col-xxl-6 col-xl-6 col-lg-12 col-md-12 mb-2 padding-mobile-size"
      >
        <div class="row input-box finance-box ms-1 p-2 mb-2">
          <div class="col-12 mb-3">
            <div class="input-box-title-box px-2">
              <span>{{ "PriceFilter" | translate : "" }}</span>
            </div>
            <div class="edit-form">
              <label class="form-label m-0">
                {{ "factorsAmountInMonth" | translate }}
              </label>
              <div
                class="input-group input-daterange"
                id="bs-datepicker-daterange"
              >
                <span class="input-group-text label-span">
                  {{ "From" | translate }}
                </span>
                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  placeholder="1,000,000"
                  [(ngModel)]="filterData.TotalPriceFrom"
                  mask="separator.0"
                  thousandSeparator=","
                />
                <span class="input-group-text">
                  {{ "Rial" | translate }}
                </span>

                <span class="input-group-text label-span">
                  {{ "To" | translate }}
                </span>

                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  placeholder="10,000,000"
                  [(ngModel)]="filterData.TotalPriceTo"
                  mask="separator.0"
                  thousandSeparator=","
                />
                <span class="input-group-text">
                  {{ "Rial" | translate }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-12 mb-3">
            <div class="edit-form">
              <label for="startdate" class="form-label m-0">
                {{ "Discount" | translate }}
              </label>
              <div
                class="input-group input-daterange"
                id="bs-datepicker-daterange"
              >
                <span class="input-group-text label-span">
                  {{ "From" | translate }}
                </span>
                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  placeholder="1,000,000"
                  [(ngModel)]="filterData.DiscountFrom"
                  mask="separator.0"
                  thousandSeparator=","
                />
                <span class="input-group-text">
                  {{ "Rial" | translate }}
                </span>

                <span class="input-group-text label-span">
                  {{ "To" | translate }}
                </span>

                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  placeholder="10,000,000"
                  [(ngModel)]="filterData.DiscountTo"
                  mask="separator.0"
                  thousandSeparator=","
                />
                <span class="input-group-text">
                  {{ "Rial" | translate }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 mt-3 mb-2 padding-mobile-size">
        <div class="row input-box stock-box ms-1 p-2 mb-2">
          <div class="col-12 mb-1 mt-3">
            <div class="input-box-title-box px-2">
              <span>{{ "StateFilter" | translate : "" }}</span>
            </div>
            <div class="edit-form">
              <div class="row checkbox-box">
                <div class="col-12 col-sm-4 col-lg-2 form-check form-check-danger position-relative">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [(ngModel)]="filterData.HasReturn"
                    [checked]="filterData.HasReturn"
                  />
                  <label class="form-check-label" for="HaveBuyReturn">{{
                    "HaveBuyReturn" | translate
                  }}</label>
                </div>
                <div class="col-12 col-sm-4 col-lg-2 form-check form-check-warning position-relative"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [(ngModel)]="filterData.HasStorage"
                    [checked]="filterData.HasStorage"
                  />
                  <label class="form-check-label" for="HaveShortage">{{
                    "HaveShortage" | translate
                  }}</label>
                </div>
                <div class="col-12 col-sm-4 col-lg-2 form-check form-check-success position-relative"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [(ngModel)]="filterData.Paid"
                    [checked]="filterData.Paid"
                  />
                  <label class="form-check-label" for="Paid">{{
                    "Paid" | translate
                  }}</label>
                </div>
                <div class="col-12 col-sm-4 col-lg-2 form-check form-check-primary position-relative"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [(ngModel)]="filterData.OnPayment"
                    [checked]="filterData.OnPayment"
                  />
                  <label class="form-check-label" for="OnPayment">{{
                    "OnPayment" | translate
                  }}</label>
                </div>
                <div class="col-12 col-sm-4 col-lg-2 form-check form-check-secondary position-relative"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [(ngModel)]="filterData.NoPayment"
                    [checked]="filterData.NoPayment"
                  />
                  <label class="form-check-label" for="NoPayment">{{
                    "NoPayment" | translate
                  }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer justify-content-center p-2">
    <button type="button" class="btn btn-light" (click)="clearEditItem()">
      <i class="bx bx-x"></i>
      {{ "Clear" | translate }}
    </button>
    <button
      type="submit"
      class="btn btn-primary me-sm-3 me-1 data-submit"
      (click)="getSingleData()"
    >
      <i class="bx bx-check"></i>
      {{ "Submit" | translate }}
    </button>
  </div>
</ng-template>

<app-pcsuccess-modal
  [showModal]="modalSuccessConfirm"
  (parentAction)="parentAction($event)"
>
</app-pcsuccess-modal>

<ng-template #CashAddModal let-modal class="modal modal-top fade">
  <app-cash-pay
    [thisItem]="cashThisItem"
    (parentActionOutput)="parentAction($event)"
  ></app-cash-pay>
</ng-template>

<ng-template #CashMultiPayment let-modal class="modal modal-top fade">
  <app-cash-multi-payment
    [thisItem]="cashThisItem"
    (parentActionOutput)="parentAction($event)"
  >
  </app-cash-multi-payment>
</ng-template>

<ng-template #CreditMultiPayment let-modal class="modal modal-top fade">
  <app-credit-multi-payment
    [thisItem]="creditThisItem"
    (parentActionOutput)="parentAction($event)"
  >
  </app-credit-multi-payment>
</ng-template>

<ng-template #CreditAddModal let-modal class="modal modal-top fade">
  <app-credit-pay
    [thisItem]="creditThisItem"
    (parentActionOutput)="parentAction($event)"
  ></app-credit-pay>
</ng-template>

<ng-template #ScanBarcodeModal let-modal class="modal modal-top fade">
  <app-scan-barcode-modal
    [itemCount]="editableItem.packageCount"
    [barcodeList]="editableItem.drugUIds"
    (parentActionOutput)="parentAction($event)"
  ></app-scan-barcode-modal>
</ng-template>

<app-pcconfrim-modal
  *ngIf="modalDeleteConfirm"
  [inputModel]="modalConfirm"
  (childEvent)="parentAction($event)"
></app-pcconfrim-modal>

<app-pcsetting-modal
  (parentAction)="parentAction($event)"
  [fields]="searchFields"
>
</app-pcsetting-modal>
